"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _Cross = _interopRequireDefault(require("../../Icons/Cross"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

var _breakpoints = _interopRequireDefault(require("../../../constants/breakpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: ", ";\n\tposition: relative;\n\tpadding: ", " ", " 0;\n\n\t.close {\n\t\tposition: absolute;\n\t\tright: 16px;\n\t\ttop: 21px;\n\t}\n\n\t@media screen and (min-width: ", ") {\n\t\tdisplay: none;\n\n\t\t.close {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Container = _styledComponents.default.div(_templateObject(), function (props) {
  return props.open ? 'block' : 'none';
}, _spacing.default.s2, _spacing.default.s2, _breakpoints.default.tablet);

Container.displayName = 'Container';

var MobileHeader = function MobileHeader(_ref) {
  var setVisible = _ref.setVisible,
      open = _ref.open,
      label = _ref.label,
      props = _objectWithoutPropertiesLoose(_ref, ["setVisible", "open", "label"]);

  return _react.default.createElement(Container, _extends({
    open: open
  }, props), label, _react.default.createElement(_Cross.default, {
    size: 14,
    className: "close",
    onClick: function onClick() {
      return setVisible(false);
    },
    "data-testid": "cross-icon"
  }));
};

MobileHeader.propTypes = {
  setVisible: _propTypes.func.isRequired,
  open: _propTypes.bool.isRequired,
  label: _propTypes.string.isRequired
};
var _default = MobileHeader;
exports.default = _default;